const numberWithSpaces = (x = 0) => {
	return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : ''
}

export default numberWithSpaces
